module.exports = __webpack_public_path__ + "assets/img/enewm.2f9ec621.png";